var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2022 24.6262L23.851 38.0918L21.4998 24.6262L7.22569 22.4082L21.4998 20.1902L23.851 6.72456L26.2022 20.1902L40.4763 22.4082L26.2022 24.6262ZM45.2683 22.4082L26.8799 19.5509L23.851 2.20408L20.8222 19.5509L2.43378 22.4082L20.8222 25.2655L23.851 42.6122L26.8799 25.2655L45.2683 22.4082Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4413 22.4221L26.0901 35.8877L23.7389 22.4221L9.46476 20.2041L23.7389 17.9861L26.0901 4.52048L28.4413 17.9861L42.7154 20.2041L28.4413 22.4221ZM47.5073 20.2041L29.1189 17.3468L26.0901 0L23.0612 17.3468L4.67285 20.2041L23.0612 23.0614L26.0901 40.4082L29.1189 23.0614L47.5073 20.2041Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4172 45L24.4461 27.6532L42.8345 24.7959L24.4461 21.9386L21.4172 4.59184L18.3884 21.9386L0 24.7959L18.3884 27.6532L21.4172 45Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.3091325b4102c4a00bbce42a5e02b123.svg";
export { ForwardRef as ReactComponent };